<template>
    <div class="calls mt-5">
        <div class="container">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Officiis expedita voluptas suscipit rem voluptates corporis, veniam in animi et pariatur quidem ea, esse maiores voluptatem delectus iusto dicta, maxime nemo!
        </div>
    </div>
</template>

<script>
    export default {
        name:'calls',
        mounted(){
            this.getData()
        },
        methods:{
            async  getData(){
                let res =  this.$store.dispatch('dashboardCalls/getData')
            }
        }
    }
</script>

<style lang="stylus" scoped>
.calls
  display flex
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/calls.vue